import { render, staticRenderFns } from "./emailMessageForm.vue?vue&type=template&id=152262da&scoped=true&"
import script from "./emailMessageForm.vue?vue&type=script&lang=js&"
export * from "./emailMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./emailMessageForm.vue?vue&type=style&index=0&id=152262da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152262da",
  null
  
)

export default component.exports